if (!customElements.get('deco-kokedama-base')) {
  customElements.define('deco-kokedama-base', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.submitBase = this.submitBase.bind(this);
      this.form.addEventListener('submit', this.submitBase, true);
      this.hidden = false;
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitBase, true);
    }

    async submitBase(event) {
      const base = this.querySelector('input:checked')?.value;
      if (!base) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || !this.form.reportValidity()) return;
      const data = new FormData(this.form);
      const id = Number(data.get('id'));
      const quantity = Number(data.get('quantity') || 1);
      if (!id || !Number.isInteger(quantity) || quantity < 1) return;
      this.busy = true;
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = true;
      const error = this.querySelector('[role="alert"]');
      error.hidden = true;
      const properties = { _deco_base: base };
      for (const [key, value] of data) {
        const match = /^properties\[(.+)\]$/.exec(key);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      const plant = { id, quantity, properties };
      if (data.get('selling_plan')) plant.selling_plan = data.get('selling_plan');
      try {
        const response = await fetch(this.dataset.add, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [plant, { id: Number(base), quantity, parent_id: id }] })
        });
        if (!response.ok) throw new Error('cart');
        window.location.assign(this.dataset.cart);
      } catch {
        error.hidden = false;
        button.disabled = false;
        this.busy = false;
      }
    }
  });
}